import React, { PureComponent } from 'react';
import Banner from '../component/banner';

class RelatedArticlesBanner extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasBanners: false,
    };
  }
  render() {
    return (
      <div className="row">
        <div
          className="col-xs-12 col-sm-6 col-md-12"
          style={
            this.state.hasBanners
              ? {
                  paddingTop: '30px',
                  paddingBottom: '15px',
                }
              : {}
          }
        >
          <Banner
            id="banner-radiokosice-sk-do-clanku-nad-podobne-clanky"
            hasBanners={hasBanners => {
              this.setState({
                hasBanners: hasBanners,
              });
            }}
          />
        </div>
      </div>
    );
  }
}

export default RelatedArticlesBanner;



// WEBPACK FOOTER //
// ./src/app/container/relatedArticlesBanner.js